
export default {
  props: {
    page: {
      type: Object,
      required: true,
    },
  },

  computed: {
    plainHost() {
      if (this.$config.appUrl) {
        return new URL(this.$config.appUrl).host
      }

      return ''
    },
  },
}
